import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import { LANGS } from "./langs";
import { store } from "../lib/storage";

const KEY = "smarti_lang";
const LanguageContext = createContext(null);

export function getStoredLang() {
  if (typeof window === "undefined") return "fr";
  const l = store.get(KEY);
  if (LANGS.some((x) => x.code === l)) return l;
  // Marché primaire Belgique/Luxembourg → FR par défaut.
  // On bascule en NL ou EN uniquement si la langue PRINCIPALE du navigateur est explicitement nl/en.
  const primary = ((window.navigator.languages && window.navigator.languages[0]) || window.navigator.language || "").toLowerCase();
  if (primary.startsWith("nl")) return "fr";
  if (primary.startsWith("en")) return "fr";
  return "fr";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getStoredLang);
  const [dict, setDict] = useState(null); // active-language dictionary (null for FR)

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  // Heavy NL/EN dictionary loaded on demand — FR visitors never download it.
  useEffect(() => {
    if (lang === "fr") { setDict(null); return; }
    let active = true;
    import("./translations").then((m) => {
      if (active) setDict((m.TR && m.TR[lang]) || null);
    });
    return () => { active = false; };
  }, [lang]);

  const setLang = useCallback((code) => {
    if (!LANGS.some((x) => x.code === code)) return;
    store.set(KEY, code);
    setLangState(code);
    // Reload so API queries refetch localized content in the chosen language.
    window.location.reload();
  }, []);

  const t = useCallback(
    (fr) => (lang === "fr" ? fr : (dict && dict[fr]) || fr),
    [lang, dict]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "fr", setLang: () => {}, t: (s) => s, langs: LANGS };
  return ctx;
}
